export enum ApiErrorCode {
  InternalServerError = "internal_server_error",
  Maintenance = "maintenance",
  Upgrading = "upgrading",
  InvalidInput = "invalid_input",
  CreditCardNotFound = "credit_card_not_found",
  StripePlanNoIncludeWhitelabel = "stripe_plan_no_include_whitelabel",
  StripePlanCreatorInvitedLimit = "stripe_plan_creator_invited_limit",
}
